import { c as _c } from "react/compiler-runtime";
import { MaterialIcon } from "@website/icons/material";
import { Button } from "@website/ui/button";
import { ListItem } from "@website/ui/list-item";
import { Popover } from "@website/ui/popover";
import { isChannel } from "@website/utils/channel/helpers";
import { ExperimentSDK } from "@website/utils/experiments/client";
import { numberConvert } from "@website/utils/number-convert";
import { useToggle } from "@website/utils/use-toggle/useToggle";
import { useOptionalChatBotContext } from "@website/widget-v2/chat-bot/context";
export function SupportAgent(t0) {
  const $ = _c(20);
  const {
    isHomePage
  } = t0;
  const chatBotContext = useOptionalChatBotContext();
  const [supportMenuIsOpen, toggleSupportMenu] = useToggle(false);
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = isChannel(["b2b", "telesale"]);
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  const channelAllowed = !t1;
  let t2;
  if ($[1] !== chatBotContext || $[2] !== isHomePage || $[3] !== toggleSupportMenu) {
    t2 = () => {
      const showChatbot = ExperimentSDK.isOn("chatbot_display") && channelAllowed && isHomePage;
      showChatbot ? chatBotContext?.openChatBot() : toggleSupportMenu();
    };
    $[1] = chatBotContext;
    $[2] = isHomePage;
    $[3] = toggleSupportMenu;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  const handleSupportClick = t2;
  let t3;
  if ($[5] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = <MaterialIcon name="support_agent" />;
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  let t4;
  if ($[6] !== handleSupportClick) {
    t4 = <Button StartIcon={t3} aria-label={"\u0646\u0645\u0627\u06CC\u0634 \u0644\u06CC\u0646\u06A9 \u0647\u0627\u06CC \u067E\u0634\u062A\u06CC\u0628\u0627\u0646\u06CC"} className="!mx-0 max-xl:!hidden" color="neutral" onClick={handleSupportClick} role="button" variant="text">پشتیبانی</Button>;
    $[6] = handleSupportClick;
    $[7] = t4;
  } else {
    t4 = $[7];
  }
  let t5;
  if ($[8] === Symbol.for("react.memo_cache_sentinel")) {
    t5 = <MaterialIcon name="support_agent" />;
    $[8] = t5;
  } else {
    t5 = $[8];
  }
  let t6;
  if ($[9] !== handleSupportClick) {
    t6 = <Button EndIcon={t5} className="!mx-0 xl:!hidden" color="neutral" equalDimension={true} onClick={handleSupportClick} variant="text" />;
    $[9] = handleSupportClick;
    $[10] = t6;
  } else {
    t6 = $[10];
  }
  let t7;
  if ($[11] === Symbol.for("react.memo_cache_sentinel")) {
    t7 = <MaterialIcon name="support_agent" />;
    $[11] = t7;
  } else {
    t7 = $[11];
  }
  let t8;
  if ($[12] === Symbol.for("react.memo_cache_sentinel")) {
    t8 = <div className="w-[312px] rounded-lg py-2"><ListItem StartIcon={t7} aria-label={"\u062A\u0645\u0627\u0633 \u0628\u0627 \u067E\u0634\u062A\u06CC\u0628\u0627\u0646\u06CC"} href="tel:+982192000123" role="link" subtitle={<div className="text-end" style={{
        direction: "ltr"
      }}>{numberConvert("+98 21 92000123", {
          locale: "fa"
        })}</div>} title={"\u062A\u0645\u0627\u0633 \u0628\u0627 \u067E\u0634\u062A\u06CC\u0628\u0627\u0646\u06CC"} /></div>;
    $[12] = t8;
  } else {
    t8 = $[12];
  }
  let t9;
  if ($[13] !== supportMenuIsOpen || $[14] !== toggleSupportMenu) {
    t9 = <Popover gap="16px" horizontalPosition="end" onClose={toggleSupportMenu} open={supportMenuIsOpen}>{t8}</Popover>;
    $[13] = supportMenuIsOpen;
    $[14] = toggleSupportMenu;
    $[15] = t9;
  } else {
    t9 = $[15];
  }
  let t10;
  if ($[16] !== t4 || $[17] !== t6 || $[18] !== t9) {
    t10 = <div className="relative">{t4}{t6}{t9}</div>;
    $[16] = t4;
    $[17] = t6;
    $[18] = t9;
    $[19] = t10;
  } else {
    t10 = $[19];
  }
  return t10;
}